import { useEffect, useState } from 'react';
import { ButtonGroupDummyData } from '../../../../constants/stocks/apiResponseTypes';
import { ButtonVariants } from '../../../Atoms/Button';
import { ButtonGroup } from '../../../Molecules/ButtonGroup';
import { GoldSilverChart } from '../../../Molecules/stockChart';
import { relDiff } from '../../../Utils/UtilFunctions';
import { getButtonVariant } from '../../../stocks/details-page/Charts/utils';
import GoldSilverService from '../Service';

export const SilverChart = ({
  data,
  city,
}: {
  data: number[][];
  city: string;
}): JSX.Element => {
  const [graphData, setGraphData] = useState(data);
  const [gram, setGram] = useState('1kg');
  const [interval, setInterval] = useState('1W');

  const onCaratChange = async () => {
    const data = await GoldSilverService.getGraphData(city, interval, `silver`);
    setGraphData(data);
  };

  useEffect(() => {
    onCaratChange();
  }, [gram, interval]);

  const CAGR =
    graphData && graphData.length && graphData.length > 2
      ? relDiff(graphData[0]?.[1], graphData[graphData.length - 1]?.[1])
      : null;

  const isCAGRpos = CAGR ? CAGR >= 0 : null;

  return (
    <>
      <GoldSilverChart
        stockData={graphData ? [...graphData] : []}
        showTimeInToolTip={false}
        gram={gram}
      ></GoldSilverChart>

      <div className="flex flex-row justify-between sm:flex-col sm:px-4 sm:justify-center">
        <ButtonGroup
          onClick={(e) => {
            const btn = e.target as HTMLInputElement;
            setGram(`${btn.id}`);
          }}
          buttons={ButtonGroupDummyData.gram}
          className="py-3 flex-auto sm:py-2 sm:pl-0 sm:text-s-10 sm:mx-auto"
          variant={ButtonVariants.blue}
          buttonClassName="py-2 px-5 font-medium"
          defaultSelectedIndex={1}
        ></ButtonGroup>

        <ButtonGroup
          onClick={(e) => {
            const btn = e.target as HTMLInputElement;
            setInterval(btn.id);
          }}
          buttons={ButtonGroupDummyData.intervals1}
          className="py-3  sm:py-2 sm:pl-0 sm:text-s-10 sm:mx-auto"
          variant={getButtonVariant(isCAGRpos)}
          buttonClassName="py-2 px-5 font-medium sm:py-1.5 sm:px-3"
        ></ButtonGroup>
      </div>
    </>
  );
};
